import sanitizeHtml from 'sanitize-html';

export const AI_HTML_OPTIONS = {
  allowedTags: [
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'strong',
    'em',
    'b',
    'i',
    'code',
    'pre',
    'blockquote',
    'a',
    'h4',
    'h5',
    'h6',
  ],
  allowedAttributes: { a: ['href', 'target', 'rel'] },
  allowedSchemes: ['http', 'https', 'mailto'],
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', { target: '_blank', rel: 'noopener noreferrer' }),
  },
};
